import {Empty} from "antd";

export function EmptyData() {
    return <Empty description={'Нет данных'}/>
}